<dss-admin-lib-applications-management-table
    *ngrxLet="assignedApplicationsList$ as unassignedApplicationsList"
    [actionButtons]="actionButtons$ | ngrxPush"
    [displayedColumns]="displayedColumns"
    [flightZoneApplications]="unassignedApplicationsList?.content"
    [page]="unassignedApplicationsList?.page"
    [isProcessing]="isProcessing$ | ngrxPush"
    [hasDataRetrievalError]="hasListDataRetrievalError$ | ngrxPush"
    [availableAssignees]="availableApplicationAssignees$ | ngrxPush"
    [hasSupervisorPermissions]="hasSupervisorPermissions$ | ngrxPush"
    [basePreviewRoutePath]="basePreviewRoutePath"
    (pageChange)="changePage($event)"
    (listRefresh)="refreshList()"
    (assigneeChange)="changeAssignee($event)"
    (kmlDownload)="downloadKml($event)"
></dss-admin-lib-applications-management-table>
